<script>
	module.exports = {
		props: ['aid', 'product', 'demo'],
		data() {
			return {
				organizerData: null
			};
		},
		components: {
			'word-detective': require('components/word-detective.vue').default
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	.word-detective-tab {
		position: relative;
	}
</style>
<template>
	<div class="word-detective-tab">
		<word-detective
			:aid="aid"
			:product="product"
			:organizer-data.sync="organizerData"
			:demo="demo"></word-detective>
	</div>
</template>
